import { on } from 'delegated-events'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lightgallery.js/dist/js/lightgallery.js'
import 'lg-thumbnail.js/dist/lg-thumbnail.js'

const openPhotoGallery = (trigger) => {
  const lightGallery = window.lightGallery
  const gallery = trigger.closest('[data-photo-gallery]')
  const galleryIndex = trigger.dataset.galleryIndex
  const startIndex = galleryIndex === undefined ? 0 : parseInt(galleryIndex) - 1
  const galleryData = JSON.parse(gallery.dataset.photoGallery)

  lightGallery(gallery, {
    index: startIndex,
    dynamic: true,
    dynamicEl: galleryData,
    thumbnail: true,
    download: false,
  })

  gallery.addEventListener(
    'onCloseAfter',
    () => {
      const uid = gallery.getAttribute('lg-uid')

      if (Object.prototype.hasOwnProperty.call(window.lgData, uid)) {
        window.lgData[uid].destroy(true)
      }
    },
    { once: true }
  )
}

on('click', '.photo-gallery-trigger', (e) => {
  e.preventDefault()

  const trigger = e.target.closest('.photo-gallery-trigger')

  openPhotoGallery(trigger)
})
